import React from 'react'

export function Arrow() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="10" fill="#93AAFB" />
      <path
        d="M8.99988 13.5L12.4998 10.0011"
        stroke="#F2E3FC"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M9 6.5L12.5 10" stroke="#F2E3FC" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}
